import Dialog from "react-a11y-dialog";
import "./Dialog.scss";

export default Dialog;
